import { useMutation, useQueryClient } from "@tanstack/react-query";
import { banAgent, unbanAgent } from "@/api/agents";
import { AgentsQueryKeys } from "@/tanstackQuery/queries/agents";

export const useBanAgent = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: banAgent,
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: [AgentsQueryKeys.All],
      });
    },
  });
};

export const useUnbanAgent = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: unbanAgent,
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: [AgentsQueryKeys.All],
      });
    },
  });
};
